module.exports = __webpack_public_path__ + "img/home-exit.b2dfd63f.svg";